export const convertDateToyyyymmdd = (date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const day = date.getDate().toString().padStart(2, '0');

  const yyyymmdd = `${year}${month}${day}`;
  return yyyymmdd;
}

export const convertyyyymmddToKebab = (date) => {
  const dateString = date.toString();

  const year = dateString.slice(0, 4);
  const month = dateString.slice(4, 6);
  const day = dateString.slice(6, 8);

  return `${year}-${month}-${day}`;
}

export const yyyymmddToDate = (date) => {
  const dateString = date.toString();

  const year =  parseInt(dateString.substring(0, 4), 10);
  const month = parseInt(dateString.substring(4, 6), 10) - 1;
  const day = parseInt(dateString.substring(6, 8), 10);

  return new Date(year, month, day);
}

export const insertColon = (time) => {
  return `${time.slice(0, 2)}:${time.slice(2, 4)}`
}

export const getYearMonth = (date) => {
  if(date === undefined) {
    return;
  }
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  return `${year}${month}`;
}
export const yyyymmToDate = (yyyymm) => {
  const year = yyyymm.slice(0, 4);
  console.log(year)
  const month = yyyymm.slice(4, 5);
  return `${year}-${month}`;
}